import { render } from "./Edit.vue?vue&type=template&id=4eaf8a44"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Edit.vue?vue&type=custom&index=0&blockType=button"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__